import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { unloadDepart, viewDepart } from '../../modules/deptModule/depart';
import TitleBox from '../../components/common/breadcrumbs/TitleBox';
import DepartRootContainer from './DepartRootContainer';
import DepartViewContainer from './DepartViewContainer';
import DeptTemplate from '../../components/deptmng/DeptTemplate';
import AskDialog from '../../components/common/dialog/AskDialog';
import * as departApi from '../../lib/api/department';
import { treeDeparts } from '../../modules/deptModule/departs';

const DeptContainer = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { id } = useParams();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [titleData, setTitleData] = useState(null);

  const { depart, error, loading } = useSelector(
    ({ departModule, loading }) => ({
      depart: departModule.depart.depart,
      error: departModule.depart.error,
      loading: loading['depart/VIEW_DEPART'],
    }),
  );

  useEffect(() => {
    if (id !== 'root') {
      dispatch(viewDepart(id));

      //언마운트될때 리덕스에서 파트너 데이터 초기화
      return () => {
        dispatch(unloadDepart());
      };
    }
  }, [id]);

  useEffect(() => {
    if (depart) {
      if (id === 'root') {
        setTitleData(null);
      } else {
        let title = {
          name: depart.dptNm,
        };
        setTitleData(title);
      }
    }
  }, [depart, id]);

  const handleGoBack = () => {
    navigate('/deptmng');
  };

  const handleEdit = () => {
    navigate(`/deptmng/${id}/edit`);
  };

  const [removeVisible, setRemoveVisible] = useState(false);
  const handleRemove = () => {
    setRemoveVisible(true);
  };
  const onRemoveCancle = () => {
    setRemoveVisible(false);
  };
  const onRemoveConfirm = () => {
    //프로젝트 삭제
    onRemove();
    setRemoveVisible(false);
  };

  const onRemove = async () => {
    try {
      const response = await departApi.removeDepart(depart.dptUuid);
      if (response.data.result === 'success') {
        enqueueSnackbar('미사용 되었습니다', {
          variant: 'error',
        });
        dispatch(treeDeparts());
        handleGoBack();
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  if (id === 'root') {
    return (
      <>
        <TitleBox
          handleGoBack={handleGoBack}
          menuName="인사관리/부서관리/최상위-회사"
          menuLink="/deptmng"
          icon="depart"
          titleData={titleData}
        />
        <DepartRootContainer type="root" />
      </>
    );
  }

  return (
    <>
      <DeptTemplate depart={depart} loading={loading} error={error}>
        <TitleBox
          edit
          remove
          handleGoBack={handleGoBack}
          menuName="인사관리/부서관리/부서상세"
          menuLink="/deptmng"
          icon="depart"
          titleData={titleData}
          handleEdit={handleEdit}
          handleRemove={handleRemove}
          editDelText="미사용"
        />
        <DepartViewContainer />
      </DeptTemplate>
      <AskDialog
        visible={removeVisible}
        title="부서 미사용"
        description="해당 부서를  미사용 처리 하시겠습니까?"
        onConfirm={onRemoveConfirm}
        onCancle={onRemoveCancle}
      />
    </>
  );
};

export default DeptContainer;
